import { CpiDashboardData } from '../types';

/**
 * Labels and number formatting for the exported deck's Overview slide.
 *
 * The deck is Dutch-only and carries no i18n, so these strings are literals
 * rather than translation keys — but they must stay in step with the on-screen
 * wording in `nl/translations.json` (`cpi.indicativeCosts`, `cpi.unit.*` and
 * friends). Kept free of pptxgenjs/echarts imports so it stays cheap to test.
 */

export function formatNL(value: number, decimals = 0): string {
  return value.toLocaleString('nl-NL', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** Euro sign in front of an amount; a missing amount stays a bare dash. */
export function formatExportCost(value: number | null | undefined): string {
  if (value === null || value === undefined) return '-';
  return `€ ${formatNL(value, 0)}`;
}

export interface ExportKpi {
  value: string;
  label: string;
  /** unit caption set behind the amount in a smaller run */
  unit?: string;
}

/** The six Overview KPI cards, mirroring CpiSummaryCards. */
export function buildOverviewKpis(d: CpiDashboardData): ExportKpi[] {
  return [
    {
      value: formatExportCost(d.indicativeCostEuros),
      label: 'Indicatieve kosten',
    },
    {
      value: formatNL(d.totalEmissionWtwTons, 0),
      label: 'CO₂ emissie totaal (WTW)',
      unit: 'ton',
    },
    {
      value: d.avgCpiWtw != null ? formatNL(d.avgCpiWtw, 3) : '-',
      label: 'CPI',
      unit: 'ton.km (WTW)',
    },
    {
      value: d.co2ePerTonWtw != null ? formatNL(d.co2ePerTonWtw, 2) : '-',
      label: 'CO₂e per ton vervoerd gewicht',
      unit: 'kg (WTW)',
    },
    {
      value: formatNL(d.totalWeightTons, 0),
      label: 'Totaal verscheept gewicht',
      unit: 'ton',
    },
    {
      value: formatNL(d.businessOrderCount, 0),
      label: 'Aantal orders',
    },
  ];
}
